import React from "react";
import Typography from "@material-ui/core/Typography/Typography";
import { findProductByName } from "../../views/productOverview/ProductHelper";
import { fromToString } from "../../../utilities/dateTimeUtils";
import { useSelector } from "react-redux";
import { TableAccordionElement } from "./TableAccordionElement";

export interface OrderDetailsAccordionProps {
    rowId: number;
    items: any;
}

export const OrderDetailsAccordion: React.FunctionComponent<OrderDetailsAccordionProps> = ({rowId, items}: OrderDetailsAccordionProps) => {
    const productsOverview = useSelector(state => state.products);

    return <TableAccordionElement rowId={rowId} labelCollapsed="Multiple items"
                                  detailElementUncollapsed={
                                      <div>
                                          <Typography variant={"h4"}>Items</Typography>
                                          {items.map((item, index) => <div key={index}><Typography variant={"body2"} style={{fontWeight: 600}}>
                                                  {findProductByName(productsOverview.products, item.product)?.name}
                                              </Typography>
                                                  <Typography variant={"body2"}>
                                                      {fromToString(item["from"], item["to"])}
                                                  </Typography>
                                                  <br />
                                              </div>
                                          )}
                                      </div>
                                  }
    />
}
